import type { FC } from 'react';
import type { Filter } from '../../../../../../../stores/filters';
import CustomUrlParamsFilter from '../../CustomUrlParamFilter';
import type { URLParamFilterConfig } from '../../hooks';

interface SearchParamsFilterProps {
  onChange: (filter: Filter) => void;
}

const filterConfig: URLParamFilterConfig = {
  param1: {
    label: 'Param 1',
    filterName: 'search_param1_filter',
    field: 'param1_suggestion',
  },
  param2: {
    label: 'Param 2',
    filterName: 'search_param2_filter',
    field: 'param2_suggestion',
  },
  param3: {
    label: 'Param 3',
    filterName: 'search_param3_filter',
    field: 'param3_suggestion',
  },
  param4: {
    label: 'Param 4',
    filterName: 'search_param4_filter',
    field: 'param4_suggestion',
  },
  param5: {
    label: 'Param 5',
    filterName: 'search_param5_filter',
    field: 'param5_suggestion',
  },
};

const SearchParamsFilter: FC<SearchParamsFilterProps> = ({ onChange }) => {
  return <CustomUrlParamsFilter onChange={onChange} paramConfig={filterConfig} />;
};

export default SearchParamsFilter;
